import React from "react"
import "../css/style.css"

const Footer = () => {
  return (
    <footer class="footer">
    
    
    <div class="container">
    <ul class="foote_bottom_ul_amrc">
    <li><a href="/">Home</a></li>
    <li><a href="/transportations">Reserve</a></li>
    <li><a href="/transportations">Services & Rates</a></li>
    <li><a href="/vehicles">Vehicles & Features</a></li>
    <li><a href="/testimonials">Testimonials</a></li>
    <li><a href="/location">Location</a></li>
    <li><a href="/contactus">Contact Us</a></li>
    <li><a href="/instructions">Instructions</a></li>
    </ul>

    <p class="text-center"><i class="fa fa-location-arrow"></i> Cabo San Lucas, B.C.S, México </p>
    <p class="text-center"><i class="fa fa-phone"></i> Calling From The U.S.: +52 624 130.3666</p>
    <p class="text-center"><i class="fa fa-phone"></i> Cabo Local: 624 130.3666</p>
    <p class="text-center"><i class="fa fa-phone"></i> Cabo Local Line 2: 624 130.3644</p>
    <p class="text-center"><i class="fab fa-facebook-f"></i> Facebook: <a style={{ color: "white" }} href="http://www.facebook.com/cabotravelsolutions" target="_blank">facebook.com/cabotravelsolutions</a> </p>
    <p class="text-center"><i class="fa fa-location-arrow"></i> Office: Our vehicles are located at Los Cabos International airport</p>
    
    <p class="text-center">Copyright @{new Date().getFullYear()} | Designed by Cabo Travel Solutions</p>
   
    </div>
    
    </footer>
    
  )
}

export default Footer
